
<div class="section" v-bind="$props">
	<slot />
</div>
